import { CommerceModel } from 'api-types';

/**
 * Utility functions for extracting consistent data from basket/cart objects
 */

/**
 * Extracts the total value from a basket, handling both number and PriceTemplate types.
 * 
 * @param basket - The basket object containing price information
 * @returns The total value as a number
 */
export const getBasketValue = (basket: CommerceModel.Basket | undefined): number => {
  if (!basket?.totalPrice) return 0;
  
  return typeof basket.totalPrice === 'number' 
    ? basket.totalPrice 
    : (basket.totalPrice.taxedPrice || 0);
};

/**
 * Extracts the currency from a basket, defaulting to DKK if not found.
 * 
 * @param basket - The basket object containing items with currency information
 * @returns The currency code as a string
 */
export const getBasketCurrency = (basket: CommerceModel.Basket | undefined): string => {
  return basket?.lines?.[0]?.priceOutput?.currency || 'DKK';
};

/**
 * Gets both value and currency from a basket in a single call.
 * 
 * @param basket - The basket object
 * @returns Object containing value and currency
 */
export const getBasketFinancials = (basket: CommerceModel.Basket | undefined) => {
  return {
    value: getBasketValue(basket),
    currency: getBasketCurrency(basket),
  };
};